<template>
  <div class="body_center_right_download">
    <div class="body_center_right_head">アプリをダウンロード</div>
    <div class="body_center_right_qrcode">
      <img src="@/components/Right/imgs/right_qrcode_img.png"/>
      <div class="right_logo_img">
        <img src="@/components/Right/imgs/right_logo_img.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/right.css"
export default {
  components: {
  },
  data () {
    return{
      
    }
  },
  created () {
  },
  methods: {
    
  }
}
</script>
<style scoped>
</style>